<div class="min-h-screen flex items-center justify-center bg-gray-100 px-4">
  <div class="bg-white p-6 rounded-md shadow text-center w-full max-w-md">
    <!-- Chargement -->
    @if (isLoading) {
      <div>
        <p class="text-gray-700">{{ "globalUi.subscriptionConfirmation.loading" | translate }}</p>
      </div>
    }

    <!-- Succès -->
    @if (!isLoading && emailConfirmed) {
      <div>
        <h1 class="text-2xl font-semibold text-green-600 mb-2">
          {{ "globalUi.subscriptionConfirmation.successTitle" | translate }}
        </h1>
        <p class="text-gray-700">
          {{ "globalUi.subscriptionConfirmation.successText" | translate }}
        </p>
      </div>
    }

    <!-- Échec -->
    @if (!isLoading && !emailConfirmed) {
      <div>
        <h1 class="text-2xl font-semibold text-red-600 mb-2">
          {{ "globalUi.subscriptionConfirmation.failureTitle" | translate }}
        </h1>
        <p class="text-gray-700">
          {{ "globalUi.subscriptionConfirmation.failureText" | translate }}
        </p>
      </div>
    }
  </div>
</div>
